module.exports = __webpack_public_path__ + "media/images/add-box-outlined-3f68a4da.svg";